import { CustomDecimalRenderer } from '../numeralRenderers';
import { companyCodeColumnDefinition,
  amountColumnDefinition,
  currencyColumnDefinition,
  descriptionColumnDefinition,
  postDateColumnDefinition,
  tradingPartnerColumnDefinition,
} from '../columnDefinitions';

export const accountActivityColumnDefs = [
  companyCodeColumnDefinition,
  tradingPartnerColumnDefinition,
  postDateColumnDefinition,
  descriptionColumnDefinition,
  currencyColumnDefinition,
  {
    ...amountColumnDefinition,
    cellRenderer: CustomDecimalRenderer,
  },
];
